import { useState } from "react";
import ArrowDown from "../../assets/img/ArrowDown.png";

import styles from "./Conditions.module.css";
import {
  ORConditions,
  TP1Conditions,
  TP2Conditions,
  TTConditions,
} from "./Data";

function Conditions({ property }) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  let conditions;
  let title;
  if (property.includes("eOR") || property.includes("OR")) {
    conditions = ORConditions;
    title = property.includes("eOR")
      ? "Osobni razvoj-hibrid (eOR)"
      : "Osobni razvoj (OR)";
  } else if (property.includes("TP1")) {
    conditions = TP1Conditions;
    title = "Terapeutski praktikum 1 (TP1)";
  } else if (property.includes("TP2")) {
    conditions = TP2Conditions;
    title = "Terapeutski praktikum 2 (TP2)";
  } else if (property.includes("TT")) {
    conditions = TTConditions;
    title = "Napredni terapeutski trening (TT)";
  } else {
    conditions = [];
    title = "";
  }
  if (!conditions.length) return null;

  return (
    <div
      onClick={() => toggleAccordion()}
      style={{
        borderColor: property.includes("TT")
          ? "rgb(140 0 0)"
          : property.includes("TP1") || property.includes("TP2")
          ? "rgb(215 60 60)"
          : property.includes("eOR") || property.includes("OR")
          ? "rgb(219 184 115)"
          : null,
      }}
    >
      <div
        className={styles.wrapper}
        style={{
          borderColor: property.includes("TT")
            ? "rgb(140 0 0)"
            : property.includes("TP1") || property.includes("TP2")
            ? "rgb(215 60 60)"
            : property.includes("eOR") || property.includes("OR")
            ? "rgb(219 184 115)"
            : null,
          backgroundColor: property.includes("TT")
            ? "rgba(241, 32, 32, 0.3)"
            : property.includes("TP1") || property.includes("TP2")
            ? "rgba(241, 32, 32, 0.1)"
            : property.includes("eOR") || property.includes("OR")
            ? "rgba(241, 179, 32, 0.1)"
            : null,
          borderBottomLeftRadius: isOpen ? 0 : 10,
          borderBottomRightRadius: isOpen ? 0 : 10,
          marginBottom: isOpen ? 0 : 20,
        }}
      >
        <p className={styles.title}>Uvjeti za upis programa: {title} </p>
        <img src={ArrowDown} className={isOpen ? "rotated" : ""} alt="" />
      </div>
      {isOpen && (
        <ul className={styles.list}>
          {conditions.map((cond, index) => (
            <li key={index} style={{ padding: 5 }}>
              {cond}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Conditions;
